import {
  input_default
} from "./chunk.7BDR237X.js";
import {
  WaClearEvent
} from "./chunk.KS3BZKGT.js";
import {
  form_control_default
} from "./chunk.2W5MNSHK.js";
import {
  Ft
} from "./chunk.NLNLKEIA.js";
import {
  MirrorValidator
} from "./chunk.RH6KZZ6S.js";
import {
  WebAwesomeFormAssociatedElement
} from "./chunk.SNETKOHC.js";
import {
  to
} from "./chunk.EH2PNIGX.js";
import {
  HasSlotController
} from "./chunk.SR35WVC6.js";
import {
  size_default
} from "./chunk.SI24X5IH.js";
import {
  Rt
} from "./chunk.HBRIRAGU.js";
import {
  LocalizeController
} from "./chunk.ZPJRWEFM.js";
import {
  appearance_default
} from "./chunk.GO6CI477.js";
import {
  watch
} from "./chunk.2NT6DI7B.js";
import {
  e,
  n,
  r,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  co
} from "./chunk.YLDBZ3SZ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/components/input/input.css
var input_default2 = ":host {\n  border-width: 0;\n}\n\n.wa-text-field {\n  flex: auto;\n  display: flex;\n  align-items: stretch;\n  justify-content: start;\n  position: relative;\n\n  border-color: inherit;\n  border-style: inherit;\n  border-radius: inherit;\n  transition: inherit;\n\n  height: var(--wa-form-control-height);\n  padding-block: 0;\n}\n\ninput {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  transition: inherit;\n\n  /* prettier-ignore */\n  background-color: rgb(118 118 118 / 0); /* ensures proper placeholder styles in webkit's date input */\n  height: calc(var(--wa-form-control-height) - var(--border-width) * 2);\n  padding-block: 0;\n  color: inherit;\n}\n\ninput::-webkit-search-decoration,\ninput::-webkit-search-cancel-button,\ninput::-webkit-search-results-button,\ninput::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\ninput:focus {\n  outline: none;\n}\n\n.prefix,\n.suffix {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  cursor: default;\n\n  &::slotted(wa-icon) {\n    color: var(--wa-color-neutral-on-quiet);\n  }\n}\n\n.prefix::slotted(*) {\n  margin-inline-end: var(--wa-space);\n}\n\n.suffix::slotted(*) {\n  margin-inline-start: var(--wa-space);\n}\n\n/*\n * Clearable + Password Toggle\n */\n\n.clear,\n.password-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: inherit;\n  color: var(--wa-color-neutral-on-quiet);\n  border: none;\n  background: none;\n  padding: 0;\n  transition: var(--wa-transition-normal) color;\n  cursor: pointer;\n\n  &:hover {\n    color: color-mix(in oklab, currentColor, var(--wa-color-mix-hover));\n  }\n\n  &:active {\n    color: color-mix(in oklab, currentColor, var(--wa-color-mix-active));\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n/* Don't show the browser's password toggle in Edge */\n::-ms-reveal {\n  display: none;\n}\n\n/* Hide the built-in number spinner */\n:host([no-spin-buttons]) input[type='number'] {\n  -moz-appearance: textfield;\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    display: none;\n  }\n}\n";

// src/components/input/input.ts
var WaInput = class extends WebAwesomeFormAssociatedElement {
  constructor() {
    super(...arguments);
    this.assumeInteractionOn = ["blur", "input"];
    this.hasSlotController = new HasSlotController(this, "hint", "label");
    this.localize = new LocalizeController(this);
    this.title = "";
    this.type = "text";
    this._value = null;
    this.defaultValue = this.getAttribute("value") || null;
    this.size = "inherit";
    this.appearance = "outlined";
    this.pill = false;
    this.label = "";
    this.hint = "";
    this.clearable = false;
    this.placeholder = "";
    this.readonly = false;
    this.passwordToggle = false;
    this.passwordVisible = false;
    this.noSpinButtons = false;
    this.form = null;
    this.required = false;
    this.spellcheck = true;
    this.withLabel = false;
    this.withHint = false;
  }
  static get validators() {
    return [...super.validators, MirrorValidator()];
  }
  /** The current value of the input, submitted as a name/value pair with form data. */
  get value() {
    if (this.valueHasChanged) {
      return this._value;
    }
    return this._value ?? this.defaultValue;
  }
  set value(val) {
    if (this._value === val) {
      return;
    }
    this.valueHasChanged = true;
    this._value = val;
  }
  handleChange(event) {
    this.relayNativeEvent(event, { bubbles: true, composed: true });
    this.value = this.input.value;
  }
  handleClearClick(event) {
    event.preventDefault();
    if (this.value !== "") {
      this.value = "";
      this.dispatchEvent(new WaClearEvent());
      this.dispatchEvent(new InputEvent("input"));
      this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
    }
    this.input.focus();
  }
  handleInput() {
    this.value = this.input.value;
  }
  handleKeyDown(event) {
    const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (event.key === "Enter" && !hasModifier) {
      setTimeout(() => {
        if (!event.defaultPrevented && !event.isComposing) {
          const form = this.getForm();
          if (!form) {
            return;
          }
          const formElements = [...form.elements];
          if (formElements.length === 1) {
            form.requestSubmit(null);
            return;
          }
          const button = formElements.find(
            (el) => el.type === "submit" && !el.matches(":disabled")
          );
          if (!button) {
            return;
          }
          if (button.tagName.toLowerCase() === "button") {
            form.requestSubmit(button);
          } else {
            button.click();
          }
        }
      });
    }
  }
  handlePasswordToggle() {
    this.passwordVisible = !this.passwordVisible;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("value")) {
      this.toggleCustomState("blank", !this.value);
    }
  }
  handleStepChange() {
    this.input.step = String(this.step);
    this.updateValidity();
  }
  /** Sets focus on the input. */
  focus(options) {
    this.input.focus(options);
  }
  /** Removes focus from the input. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the input. */
  select() {
    this.input.select();
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
    this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(replacement, start, end, selectMode = "preserve") {
    const selectionStart = start ?? this.input.selectionStart;
    const selectionEnd = end ?? this.input.selectionEnd;
    this.input.setRangeText(replacement, selectionStart, selectionEnd, selectMode);
    if (this.value !== this.input.value) {
      this.value = this.input.value;
    }
  }
  /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */
  showPicker() {
    if ("showPicker" in HTMLInputElement.prototype) {
      this.input.showPicker();
    }
  }
  /** Increments the value of a numeric input type by the value of the step attribute. */
  stepUp() {
    this.input.stepUp();
    if (this.value !== this.input.value) {
      this.value = this.input.value;
    }
  }
  /** Decrements the value of a numeric input type by the value of the step attribute. */
  stepDown() {
    this.input.stepDown();
    if (this.value !== this.input.value) {
      this.value = this.input.value;
    }
  }
  formResetCallback() {
    this.value = this.defaultValue;
    super.formResetCallback();
  }
  render() {
    const hasLabelSlot = this.hasUpdated ? this.hasSlotController.test("label") : this.withLabel;
    const hasHintSlot = this.hasUpdated ? this.hasSlotController.test("hint") : this.withHint;
    const hasLabel = this.label ? true : !!hasLabelSlot;
    const hasHint = this.hint ? true : !!hasHintSlot;
    const hasClearIcon = this.clearable && !this.disabled && !this.readonly;
    const isClearIconVisible = (
      // prevents hydration mismatch errors.
      (co || this.hasUpdated) && hasClearIcon && (typeof this.value === "number" || this.value && this.value.length > 0)
    );
    return ke`
      <label part="form-control-label label" class="label" for="input" aria-hidden=${hasLabel ? "false" : "true"}>
        <slot name="label">${this.label}</slot>
      </label>

      <div part="input" class="wa-text-field">
        <slot name="prefix" part="prefix" class="prefix"></slot>

        <input
          part="base"
          id="input"
          class="control"
          type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
          title=${this.title}
          name=${to(this.name)}
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          ?required=${this.required}
          placeholder=${to(this.placeholder)}
          minlength=${to(this.minlength)}
          maxlength=${to(this.maxlength)}
          min=${to(this.min)}
          max=${to(this.max)}
          step=${to(this.step)}
          .value=${Ft(this.value || "")}
          autocapitalize=${to(this.autocapitalize)}
          autocomplete=${to(this.autocomplete)}
          autocorrect=${to(this.autocorrect)}
          ?autofocus=${this.autofocus}
          spellcheck=${this.spellcheck}
          pattern=${to(this.pattern)}
          enterkeyhint=${to(this.enterkeyhint)}
          inputmode=${to(this.inputmode)}
          aria-describedby="hint"
          @change=${this.handleChange}
          @input=${this.handleInput}
          @keydown=${this.handleKeyDown}
        />

        ${isClearIconVisible ? ke`
              <button
                part="clear-button"
                class="clear"
                type="button"
                aria-label=${this.localize.term("clearEntry")}
                @click=${this.handleClearClick}
                tabindex="-1"
              >
                <slot name="clear-icon">
                  <wa-icon name="circle-xmark" library="system" variant="regular"></wa-icon>
                </slot>
              </button>
            ` : ""}
        ${this.passwordToggle && !this.disabled ? ke`
              <button
                part="password-toggle-button"
                class="password-toggle"
                type="button"
                aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                @click=${this.handlePasswordToggle}
                tabindex="-1"
              >
                ${!this.passwordVisible ? ke`
                      <slot name="show-password-icon">
                        <wa-icon name="eye" library="system" variant="regular"></wa-icon>
                      </slot>
                    ` : ke`
                      <slot name="hide-password-icon">
                        <wa-icon name="eye-slash" library="system" variant="regular"></wa-icon>
                      </slot>
                    `}
              </button>
            ` : ""}

        <slot name="suffix" part="suffix" class="suffix"></slot>
      </div>

      <slot
        name="hint"
        part="hint"
        class=${Rt({
      "has-slotted": hasHint
    })}
        aria-hidden=${hasHint ? "false" : "true"}
        >${this.hint}</slot
      >
    `;
  }
};
WaInput.shadowStyle = [size_default, appearance_default, form_control_default, input_default, input_default2];
WaInput.shadowRootOptions = { ...WebAwesomeFormAssociatedElement.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  e("input")
], WaInput.prototype, "input", 2);
__decorateClass([
  n()
], WaInput.prototype, "title", 2);
__decorateClass([
  n({ reflect: true })
], WaInput.prototype, "type", 2);
__decorateClass([
  r()
], WaInput.prototype, "value", 1);
__decorateClass([
  n({ attribute: "value", reflect: true })
], WaInput.prototype, "defaultValue", 2);
__decorateClass([
  n({ reflect: true, initial: "medium" })
], WaInput.prototype, "size", 2);
__decorateClass([
  n({ reflect: true })
], WaInput.prototype, "appearance", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaInput.prototype, "pill", 2);
__decorateClass([
  n()
], WaInput.prototype, "label", 2);
__decorateClass([
  n({ attribute: "hint" })
], WaInput.prototype, "hint", 2);
__decorateClass([
  n({ type: Boolean })
], WaInput.prototype, "clearable", 2);
__decorateClass([
  n()
], WaInput.prototype, "placeholder", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaInput.prototype, "readonly", 2);
__decorateClass([
  n({ attribute: "password-toggle", type: Boolean })
], WaInput.prototype, "passwordToggle", 2);
__decorateClass([
  n({ attribute: "password-visible", type: Boolean })
], WaInput.prototype, "passwordVisible", 2);
__decorateClass([
  n({ attribute: "no-spin-buttons", type: Boolean })
], WaInput.prototype, "noSpinButtons", 2);
__decorateClass([
  n({ reflect: true })
], WaInput.prototype, "form", 2);
__decorateClass([
  n({ type: Boolean, reflect: true })
], WaInput.prototype, "required", 2);
__decorateClass([
  n()
], WaInput.prototype, "pattern", 2);
__decorateClass([
  n({ type: Number })
], WaInput.prototype, "minlength", 2);
__decorateClass([
  n({ type: Number })
], WaInput.prototype, "maxlength", 2);
__decorateClass([
  n()
], WaInput.prototype, "min", 2);
__decorateClass([
  n()
], WaInput.prototype, "max", 2);
__decorateClass([
  n()
], WaInput.prototype, "step", 2);
__decorateClass([
  n()
], WaInput.prototype, "autocapitalize", 2);
__decorateClass([
  n()
], WaInput.prototype, "autocorrect", 2);
__decorateClass([
  n()
], WaInput.prototype, "autocomplete", 2);
__decorateClass([
  n({ type: Boolean })
], WaInput.prototype, "autofocus", 2);
__decorateClass([
  n()
], WaInput.prototype, "enterkeyhint", 2);
__decorateClass([
  n({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (value) => !value || value === "false" ? false : true,
      toAttribute: (value) => value ? "true" : "false"
    }
  })
], WaInput.prototype, "spellcheck", 2);
__decorateClass([
  n()
], WaInput.prototype, "inputmode", 2);
__decorateClass([
  n({ attribute: "with-label", type: Boolean })
], WaInput.prototype, "withLabel", 2);
__decorateClass([
  n({ attribute: "with-hint", type: Boolean })
], WaInput.prototype, "withHint", 2);
__decorateClass([
  watch("step", { waitUntilFirstUpdate: true })
], WaInput.prototype, "handleStepChange", 1);
WaInput = __decorateClass([
  t("wa-input")
], WaInput);

export {
  WaInput
};
